const AliasTypes = {
  Account: 'A',
  InfoAccount: 'I',
  Category: 'C',
};

module.exports = {
  AliasTypes,
};
